// extracted by mini-css-extract-plugin
module.exports = {"activityLink":"style-module__activityLink___3ZFzj"};